<div class="rating-item">
  <div class="rating-sidebar">
    <div class="user-avatar">
      {{ rating.customer ? rating.customer.charAt(0).toUpperCase() : 'G' }}
    </div>
  </div>

  <div class="rating-content">
    <div class="rating-top">
      <div class="user-meta">
        <span class="user-name">{{ rating.customer }}</span>
        <span class="review-date">le {{ rating.date | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="stars-wrapper">
        <gob-stars [stars]="rating.rate"></gob-stars>
      </div>
    </div>

    <div class="rating-body">
      <p class="review-text">{{ rating.review }}</p>
    </div>
  </div>
</div>